/* ================================================================
   PRODUCT DETAIL PAGE JS
================================================================ */

function initProductPage(sectionId, productId) {
  'use strict';

  var variantsData = JSON.parse(
    document.getElementById('pdp-variants-json-' + sectionId).textContent
  );
  var imagesData = JSON.parse(
    document.getElementById('pdp-images-json-' + sectionId).textContent
  );

  var form        = document.querySelector('[data-pdp-form]');
  var variantInput = form ? form.querySelector('[data-pdp-variant-id]') : null;
  var priceEl     = document.querySelector('[data-pdp-price-display]');
  var compareEl   = document.querySelector('[data-pdp-compare]');
  var atcBtn      = document.querySelector('[data-pdp-atc]');
  var buyNowBtn   = document.querySelector('[data-pdp-buynow]');
  var mainImg     = document.getElementById('pdp-main-img');
  var thumbs      = document.querySelectorAll('[data-pdp-thumb]');
  var thumbsWrap  = document.querySelector('.pdp-gallery__thumbs');
  var prevBtn     = document.querySelector('[data-pdp-prev]');
  var nextBtn     = document.querySelector('[data-pdp-next]');
  var qtyInput    = document.querySelector('[data-pdp-qty]');
  var qtyDec      = document.querySelector('[data-pdp-qty-dec]');
  var qtyInc      = document.querySelector('[data-pdp-qty-inc]');


  var selectedOptions = {};
  var currentGalleryIdx = 0;

  /* ---- Init selected options from active swatches/pills ---- */
  document.querySelectorAll('.pdp-swatch.is-active, .pdp-pill.is-active').forEach(function (btn) {
    var idx = parseInt(btn.dataset.optIdx, 10);
    selectedOptions[idx] = btn.dataset.optVal;
  });

  updateOptionAvailability();

  /* ---- Option click ---- */
  document.querySelectorAll('.pdp-swatch, .pdp-pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.optIdx, 10);
      var val = btn.dataset.optVal;
      selectedOptions[idx] = val;

      /* Update active state in same option group */
      document.querySelectorAll('[data-opt-idx="' + idx + '"]').forEach(function (b) {
        var active = b.dataset.optVal === val;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', String(active));
      });

      /* Update selected label */
      var labelEl = document.querySelector('[data-opt-selected="' + idx + '"]');
      if (labelEl) {
        var display = val.indexOf('_') !== -1 ? val.split('_').slice(1).join('_') : val;
        labelEl.textContent = display;
      }

      var matched = findVariant();
      if (matched) updateVariant(matched);

      updateOptionAvailability();
    });
  });

  function findVariant() {
    return variantsData.find(function (v) {
      return Object.keys(selectedOptions).every(function (idx) {
        var optKey = 'option' + (parseInt(idx, 10) + 1);
        return v[optKey] === selectedOptions[idx];
      });
    }) || null;
  }

  function updateOptionAvailability() {
    document.querySelectorAll('.pdp-swatch, .pdp-pill').forEach(function (btn) {
      var optIdx = parseInt(btn.dataset.optIdx, 10);
      var btnVal = btn.dataset.optVal;

      var isAvailable = variantsData.some(function (v) {
        var vVal = v['option' + (optIdx + 1)];
        if (vVal !== btnVal) return false;
        if (!v.available) return false;

        return Object.keys(selectedOptions).every(function (idxStr) {
          var otherOptIdx = parseInt(idxStr, 10);
          if (otherOptIdx === optIdx) return true;
          return v['option' + (otherOptIdx + 1)] === selectedOptions[otherOptIdx];
        });
      });

      btn.classList.toggle('is-disable', !isAvailable);

      var svg = btn.querySelector('svg');
      if (!isAvailable) {
        if (!svg) {
          btn.insertAdjacentHTML('beforeend', '<svg width="37" height="17" viewBox="0 0 37 17" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="38.6762" height="1.8" transform="matrix(-0.920407 0.390961 0.390961 0.920407 35.5978 0)" fill="#40484F"/></svg>');
        }
      } else {
        if (svg) svg.remove();
      }
    });
  }

  function formatMoney(cents) {
    return 'Rp' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function updateVariant(variant) {
    /* Variant ID */
    if (variantInput) variantInput.value = variant.id;

    /* Price */
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    /* ATC availability */
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    }

    /* URL update without reload */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    /* Sync gallery to variant featured image */
    if (variant.featured_image && variant.featured_image.position) {
      var imgIdx = variant.featured_image.position - 1;
      if (imgIdx >= 0 && imgIdx < imagesData.length) {
        setGalleryImage(imgIdx);
      }
    }

    /* Update max quantity for the new variant */
    updateQtyInputMax(variant);
  }

  /* ---- Gallery ---- */
  function keepThumbInView(thumb) {
    if (!thumbsWrap || !thumb) return;

    var targetLeft = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.offsetWidth) / 2;
    thumbsWrap.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: 'smooth'
    });
  }

  function setGalleryImage(idx) {
    if (!imagesData[idx]) return;
    currentGalleryIdx = idx;
    if (mainImg) {
      // Fade out
      mainImg.style.opacity = '0';
      
      // Wait for CSS transition (200ms) before swapping src
      setTimeout(function () {
        mainImg.src = imagesData[idx].src;
        mainImg.removeAttribute('srcset');
        mainImg.alt = imagesData[idx].alt;
        
        // Fade back in when the new image is fully loaded
        mainImg.onload = function () { 
          mainImg.style.opacity = '1'; 
        };
        // Fallback for cached images that might not fire onload
        if (mainImg.complete) {
          mainImg.style.opacity = '1';
        }
      }, 200);
    }
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === idx);
    });
    if (thumbs[idx]) {
      keepThumbInView(thumbs[idx]);
    }
  }

  thumbs.forEach(function (thumb, idx) {
    thumb.addEventListener('click', function () { setGalleryImage(idx); });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () {
    setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
  });

  /* ---- Trackpad / Mousewheel & Touch Gesture navigation on main image ---- */
  var mainContainer = document.querySelector('.pdp-gallery__main');
  if (mainContainer) {
    var wheelLock = false;
    mainContainer.addEventListener('wheel', function (e) {
      if (imagesData.length <= 1) return;
      var delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      if (Math.abs(delta) < 15) return;

      e.preventDefault();
      if (wheelLock) return;
      wheelLock = true;

      if (delta > 0) {
        setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
      } else {
        setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
      }

      setTimeout(function () {
        wheelLock = false;
      }, 400);
    }, { passive: false });

    /* Touch Swipe */
    var touchStartX = 0;
    mainContainer.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) {
        touchStartX = e.touches[0].clientX;
      }
    }, { passive: true });

    mainContainer.addEventListener('touchend', function (e) {
      if (imagesData.length <= 1) return;
      if (e.changedTouches.length === 1) {
        var touchEndX = e.changedTouches[0].clientX;
        var diffX = touchEndX - touchStartX;
        if (Math.abs(diffX) > 30) {
          if (diffX < 0) {
            setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
          } else {
            setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
          }
        }
      }
    }, { passive: true });
  }

  /* ---- Buy Now button ---- */
  /* ---- Modal Peringatan Stok & Helper ---- */
  var stockModal = document.getElementById('pdp-stock-modal');
  var stockModalDesc = document.getElementById('pdp-stock-modal-desc');
  var stockModalCount = document.getElementById('pdp-stock-modal-count');

  // Menampilkan popup modal jika stok tidak mencukupi atau mencapai batas maksimal
  function showStockModal(msg, availableStock) {
    if (!stockModal) {
      alert(msg);
      return;
    }
    if (stockModalDesc) stockModalDesc.textContent = msg;
    if (stockModalCount) stockModalCount.textContent = availableStock;
    stockModal.classList.add('is-open');
    stockModal.setAttribute('aria-hidden', 'false');
  }

  // Menutup popup modal peringatan stok
  function hideStockModal() {
    if (!stockModal) return;
    stockModal.classList.remove('is-open');
    stockModal.setAttribute('aria-hidden', 'true');
  }

  // Event listener tombol close untuk menutup modal peringatan stok
  if (stockModal) {
    stockModal.querySelectorAll('[data-stock-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', hideStockModal);
    });
  }

  // Mengambil batas maksimum stok yang tersedia untuk varian yang dipilih
  function getMaxStock(variantId) {
    var vId = variantId || (variantInput ? variantInput.value : null);
    if (!vId) return 99;
    var matched = variantsData.find(function (v) { return String(v.id) === String(vId); });
    if (matched && matched.inventory_management && matched.inventory_policy === 'deny') {
      var inv = parseInt(matched.inventory_quantity, 10);
      if (!isNaN(inv) && inv > 0) return inv;
      if (inv <= 0) return 99; // fallback jika stok terbaca 0 namun produk masih bisa dibeli
    }
    return 99;
  }

  // Memperbarui atribut max pada input kuantitas saat varian/shade produk diganti
  function updateQtyInputMax(variant) {
    if (!qtyInput) return;
    var maxStock = getMaxStock(variant ? variant.id : null);
    qtyInput.max = maxStock;
    var currentVal = parseInt(qtyInput.value, 10) || 1;
    if (currentVal > maxStock) {
      qtyInput.value = Math.max(1, maxStock);
    }
  }

  // Validasi jika pembeli mengetik angka kuantitas secara manual melebihi batas stok
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var maxStock = getMaxStock();
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) {
        qtyInput.value = 1;
      } else if (val > maxStock) {
        qtyInput.value = maxStock;
        showStockModal('Jumlah yang Anda masukkan melebihi batas stok produk yang tersedia.', maxStock);
      }
    });
  }

  // Handler tombol Buy Now: validasi stok sebelum langsung checkout ke halaman keranjang
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var vId = variantInput ? variantInput.value : null;
      if (!vId) return;
      var maxStock = getMaxStock(vId);
      var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (q > maxStock) {
        showStockModal('Maaf, jumlah pembelian melebihi stok yang tersedia saat ini.', maxStock);
        if (qtyInput) qtyInput.value = maxStock;
        return;
      }
      // Buy Now pindah halaman lewat permalink, bukan /cart/add.js, jadi
      // analytics tidak bisa mengintipnya dari network. Laporkan di sini,
      // setelah validasi stok lolos dan tepat sebelum navigasi.
      if (typeof window.phTrackBuyNow === 'function') {
        var atcVariant = variantsData.find(function (v) {
          return String(v.id) === String(vId);
        });
        window.phTrackBuyNow(vId, q, atcVariant);
      }
      window.location.href = '/cart/' + vId + ':' + q;
    });
  }

  // Mengubah kuantitas saat tombol stepper (+) atau (-) ditekan
  function handleQtyChange(delta) {
    var input = document.querySelector('[data-pdp-qty]');
    if (!input) return;
    var currentVal = parseInt(input.value, 10) || 1;
    var maxStock = getMaxStock();

    if (delta < 0) {
      if (currentVal > 1) {
        input.value = currentVal - 1;
      }
    } else if (delta > 0) {
      if (currentVal >= maxStock) {
        showStockModal('Jumlah pesanan sudah mencapai batas maksimum stok yang tersedia.', maxStock);
        return;
      }
      input.value = Math.min(maxStock, currentVal + 1);
    }
  }

  // Event listener tombol kurangi kuantitas (-)
  if (qtyDec) {
    qtyDec.addEventListener('click', function (e) {
      e.preventDefault();
      handleQtyChange(-1);
    });
  }

  // Event listener tombol tambah kuantitas (+)
  if (qtyInc) {
    qtyInc.addEventListener('click', function (e) {
      e.preventDefault();
      handleQtyChange(1);
    });
  }

  // Delegasi fallback jika tombol stepper ter-render ulang secara dinamis
  document.addEventListener('click', function (e) {
    var decBtn = e.target.closest('[data-pdp-qty-dec]');
    var incBtn = e.target.closest('[data-pdp-qty-inc]');
    if (decBtn && !qtyDec) {
      e.preventDefault();
      handleQtyChange(-1);
    } else if (incBtn && !qtyInc) {
      e.preventDefault();
      handleQtyChange(1);
    }
  });

  /* ---- Add to Cart ---- */
  function showCartToast() {
    var toast = document.getElementById('cart-toast-popover');
    if (!toast) return;

    if (window.jQuery) {
      window.jQuery('html, body').animate({ scrollTop: 0 }, 400);
      var $toast = window.jQuery(toast);
      $toast.addClass('is-show');
      clearTimeout(showCartToast._timer);
      showCartToast._timer = setTimeout(function () {
        $toast.removeClass('is-show');
      }, 5000);
      return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
    toast.classList.add('is-show');
    clearTimeout(showCartToast._timer);
    showCartToast._timer = setTimeout(function () {
      toast.classList.remove('is-show');
    }, 5000);
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (!variantInput || !variantInput.value) return;
      var maxStock = getMaxStock(variantInput.value);
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      if (qty > maxStock) {
        showStockModal('Maaf, stok tidak mencukupi untuk jumlah yang Anda minta.', maxStock);
        if (qtyInput) qtyInput.value = maxStock;
        return;
      }

      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: qty })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data && data.description ? data.description : 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          updateCartCount();
          showCartToast();
          atcBtn.textContent = 'ADDED!';
          setTimeout(function () { atcBtn.textContent = 'ADD TO CART'; }, 1800);
        })
        .catch(function (error) {
          alert(error.message || 'Could not add to cart. Please try again.');
        })
        .finally(function () {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
        });
    });
  }

  function updateFreebieProgress(cart) {
    if (typeof window.updateFreebieProgress === 'function' && window.updateFreebieProgress !== updateFreebieProgress) {
      window.updateFreebieProgress(cart);
      return;
    }

    var bars = document.querySelectorAll('.cart-freebie');
    if (!bars.length || !cart) return;

    bars.forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
      var freebieLine = 0;
      var hasFreebie = false;

      if (cart.items && cart.items.length) {
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          if (props._freebie === 'true' || props._freebie === true) {
            freebieLine += item.final_line_price || 0;
            hasFreebie = true;
          }
        });
      }

      var eligible = (cart.total_price || 0) - freebieLine;
      var remaining = threshold - eligible;
      var percent = threshold > 0 ? Math.round((eligible * 100) / threshold) : 100;
      if (percent > 100) percent = 100;
      if (percent < 0) percent = 0;

      el.setAttribute('data-eligible-total', String(eligible));
      el.setAttribute('data-has-freebie', hasFreebie ? 'true' : 'false');

      var textEl = el.querySelector('[data-freebie-message]');
      if (textEl) {
        if (hasFreebie || remaining <= 0) {
          textEl.textContent = 'Kamu sudah berhak mendapatkan 1 produk gratis!';
        } else {
          textEl.textContent =
            'Tambahkan ' + formatMoney(remaining) + ' untuk mendapatkan 1 produk gratis';
        }
      } else {
        textEl = el.querySelector('.cart-freebie__top > span:first-child');
        if (textEl) {
          if (remaining > 0) {
            textEl.textContent =
              'Tambahkan ' + formatMoney(remaining) + ' untuk mendapatkan 1 produk gratis';
          } else {
            textEl.textContent = "You're eligible for freebies!";
          }
        }
      }

      var progress = el.querySelector('.cart-freebie__progress span');
      if (progress) progress.style.width = percent + '%';
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-action-btn__badge').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
        updateFreebieProgress(cart);
      });
  }



  /* ---- Product information tabs ---- */
  document.querySelectorAll('[data-pdp-tabs]').forEach(function (tabs) {
    var buttons = Array.from(tabs.querySelectorAll('.pdp-tabs__button'));
    var panels = Array.from(tabs.querySelectorAll('.pdp-tabs__panel'));

    function activateTab(button) {
      buttons.forEach(function (item) {
        var isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach(function (panel) {
        var isTarget = panel.id === button.getAttribute('aria-controls');
        panel.hidden = !isTarget;

        if (isTarget) {
          panel.classList.add('is-visible');

          if (panel.querySelector('#judgeme_product_reviews, .jdgm-review-widget')) {
            setTimeout(function () {
              if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
                window.jdgm.initializeWidgets();
              } else if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
                window.jdgm.loadWidgets();
              } else {
                document.dispatchEvent(new CustomEvent('jdgm.widget.refresh'));
              }
            }, 50);
          }
        }
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        activateTab(button);
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var nextButton = buttons[(index + direction + buttons.length) % buttons.length];
        activateTab(nextButton);
        nextButton.focus();
      });
    });
  });

  /* ---- Product Recommendations (YMAL) ---- */
  var recsWrap = document.querySelector('[data-recommendations-url]');
  if (recsWrap) {
    var recsUrl = recsWrap.dataset.recommendationsUrl;
    fetch(recsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var track = doc.querySelector('.scroll-row--md, .product-grid, .products-grid');
        var recsContainer = document.getElementById('pdp-recs-' + sectionId);
        if (track && recsContainer) {
          recsContainer.innerHTML = track.innerHTML;
        }
      })
      .catch(function () {});
  }
}

